import { render, staticRenderFns } from "./ComplaintSectorTable.vue?vue&type=template&id=a432597e&"
import script from "./ComplaintSectorTable.vue?vue&type=script&lang=js&"
export * from "./ComplaintSectorTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports